var $j = jQuery.noConflict();

$j(document).ready(function ($) {
    $.cookieBar({
        message    : $('#country_not_allowed_message').html(),
        acceptText : 'OK',
        expireDays: 30,
        fixed : true,
        zindex : 20
    });
});